import { render } from "./CourseEnrollment.vue?vue&type=template&id=b4622c58&ts=true"
import script from "./CourseEnrollment.vue?vue&type=script&lang=ts"
export * from "./CourseEnrollment.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__